import Config from '@config';
import { initializeEquipmentManufacturerApi } from '@gasbi/shared/common/features/equipmentManufacturer';

import axiosBaseQuery from '@/utils/axiosBaseQuery';

export const {
  equipmentManufacturerApi,
  useGetEquipmentManufacturerByIdQuery,
  useGetEquipmentManufacturersQuery,
  useCreateEquipmentManufacturerMutation,
  useUpdateEquipmentManufacturerMutation,
  useGetEquipmentManufacturersInfiniteQuery,
} = initializeEquipmentManufacturerApi(
  Config.VITE_API_CLIENT_URL,
  axiosBaseQuery,
);
